import { Box, Paper, Typography, Button, styled } from '@mui/material';

// Styled components for TripDetailPanel
export const DetailSection = styled(Paper)(({ theme }) => ({
  backgroundColor: '#161616',
  color: '#ffffff',
  marginBottom: theme.spacing(1.5),
  borderRadius: theme.spacing(0.75),
  overflow: 'hidden',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
  border: '1px solid rgba(255, 255, 255, 0.05)'
}));

export const SectionContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  paddingTop: theme.spacing(0.75),
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const DetailContainer = styled(Box)(({ theme }) => ({
  maxHeight: 'calc(100vh - 180px)',
  overflowY: 'auto',
  padding: theme.spacing(1.5),
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#121212',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#333',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  }
}));

// Success ribbon that appears at the top of the screen
export const SuccessRibbon = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.success.main,
  color: theme.palette.success.contrastText,
  padding: theme.spacing(1.5),
  zIndex: 1300,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
  transform: 'translateY(0)',
  transition: 'transform 0.3s ease-in-out',
}));

export const InfoRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  '& > *': {
    padding: theme.spacing(1),
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
    borderRadius: theme.spacing(0.75),
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.04)'
    }
  }
}));

export const InfoLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.grey[400],
  fontSize: '0.75rem',
  letterSpacing: '0.4px',
  marginBottom: theme.spacing(0.5),
  textTransform: 'uppercase',
  fontFamily: '"Poppins", sans-serif'
}));

export const InfoValue = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: '#ffffff',
  fontSize: '0.875rem',
  fontFamily: '"Poppins", sans-serif',
  lineHeight: 1.4
}));

export const InfoField = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column'
}));


export const SectionIcon = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
 
export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(0.5),
  color: '#0088ff',
  fontSize: '0.85rem',
  letterSpacing: '0.4px',
  textTransform: 'uppercase',
  fontFamily: '"Poppins", sans-serif',
  textShadow: '0 0 10px rgba(0, 136, 255, 0.3)'
}));
 
export const ActionButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#0055ff',
  color: '#ffffff',
  fontSize: '0.75rem',
  padding: '4px 12px',
  minHeight: '28px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  borderRadius: '4px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: '#0044cc',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.3)'
  }
}));
